import React from 'react';

import { useTranslation } from 'react-i18next';

import AddToList from '../../assets/icons/AddToList';
import RemoveFromList from '../../assets/icons/RemoveFromList';
import styled from '../../styled';
import { colorsPalette } from '../../theme';
import { LightTooltip } from '../UI/LightTooltip';

const ToggleFromList = ({ isAdd = true, onClick, noBackground = false, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <LightTooltip
      placement="top"
      // @ts-ignore
      title={isAdd ? t('common.addToWatchlist') : t('common.removeFromWatchlist')}
    >
      <Wrapper onClick={onClick} noBackground={noBackground} disabled={disabled}>
        {isAdd ? <StyledAddIcon /> : <StyledRemoveIcon />}
      </Wrapper>
    </LightTooltip>
  );
};

export default ToggleFromList;

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'noBackground' && prop !== 'disabled',
})`
  width: ${({ noBackground }) => (noBackground ? 'initial' : '40px')};
  height: ${({ noBackground }) => (noBackground ? 'initial' : '40px')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${({ noBackground }) =>
    noBackground ? 'initial' : colorsPalette.violetAnalyticsCard};
  cursor: pointer;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
  transition: opacity 0.6s;
`;
const createIcon = (tag) => styled(tag)`
  position: relative;
  top: 2px;
  left: 2px;
`;
const StyledAddIcon = createIcon(AddToList);
const StyledRemoveIcon = createIcon(RemoveFromList);
